const config = {
  operatorApiGateway: {
    BASE_URL_1: `${process.env.REACT_APP_ADMIN_BACKEND_URL_HTTP}`
  }
}

export default config
